export const buildPreview = (content: string) => `
  <!DOCTYPE html>
  <html>
    <head>
      <style>
        body {
          color: rgba(0, 0, 0, 0.87);
          font-family: "Open Sans", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "sans-serif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
          text-align: center;
        }

        h1 {
          font-size: 40px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          margin-bottom: 24px;
        }
    
        img {
          width: 100%;
          max-width: 201px;
        }
    
        p {
          font-size: 16px;
          line-height: 1.5;
          max-width: 480px;
          letter-spacing: 0.15px;
          text-align: center;
          margin: 0 auto 24px;
          font-weight: 600;
        }
    
        a {
          display: inline-block;
          text-transform: uppercase;
          text-decoration: none;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.25;
          letter-spacing: normal;
          color: #245d38;
          padding-left: 27px;
          margin: 0 14px 25px 14px;
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAElBMVEUAAAAkXDgkXDgkXjgkXTj////NAyhtAAAABHRSTlMAd3+ApzL+VgAAAAFiS0dEBfhv6ccAAAA4SURBVBjTY2AgHrC4uDhQi8PoAgYKEJ4IiO2ELKUA0yOCkABLKSDcI+KE5DhmA6I8AAIOmBySAQBjuw7hAT3jRQAAAABJRU5ErkJggg==) left center no-repeat;
        }
      </style>
    </head>
    <body>
      ${content}
    </body>
  </html>
`;
